const styles = theme => ({
  tooltip: {
    fontSize: 14,
  },
  label: {
    fontWeight: 'bold',
    paddingRight: '10px',
  },
  value: {
    fontWeight: 'normal',
    textAlign: 'right',
  },
});

export default styles;
